var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('div',{staticClass:"m-t-25 sale-info"},[_c('total')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }